export const toBase64 = async (file: File) => {
  return await new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => { return resolve(reader.result as string); };
    reader.onerror = reject;
  });
};
